import clsx from 'clsx';
import React from 'react';

interface ISectionTitle {
  intro?: string;
  title: string;
  className?: string;
  align?: 'left' | 'center';
}

const SectionTitle = ({
  intro,
  title,
  className,
  align = 'center',
}: ISectionTitle) => {
  return (
    <div
      className={clsx(
        'flex flex-col space-y-2',
        align === 'center' && 'items-center justify-center text-center',
        className
      )}
    >
      {intro && (
        <div className="font-orton text-xl text-pink-500 md:text-4xl">
          {intro}
        </div>
      )}
      <h2 className="font-dharma text-8xl font-black italic leading-none text-cream md:text-10xl">
        {title}
      </h2>
    </div>
  );
};

export default SectionTitle;
